import AddNewWork from "./AddNewProject";
import { DashboardOperationsUserContainer } from "./style";
import PieChartProjects from "./PieChartProjects";
import { useSelector } from "react-redux";
import { selectAuthData } from "../../../../redux/features/auth/authSlice";

import TicketsReview from "./TicketsReview";
import RowContainer from "../../../common/RowContainer";
import { useGetProjectsByUserIdQuery } from "../../../../redux/features/projects/projectsApi";
import { useGetTicketsByUserIdQuery } from "../../../../redux/features/tickets/ticketsApi";

export default function DashboardUser() {
  //REDUX
  const userData = useSelector(selectAuthData);
  const userId = userData?.userData?.id;

  const { data: projectsData } = useGetProjectsByUserIdQuery(
    {
      userId: userData?.userData?.id,
      page: 1,
      queryFilters: {
        project_status: null,
        brand: null,
        model: null,
        vehicle_type: null,
        modified_at: null,
        created_at: null,
      },
    },
    {
      skip: !userData?.userData?.id,
    }
  );

  const {
    data: ticketsData,
    isLoading,
    isError,
  } = useGetTicketsByUserIdQuery(
    {
      userId: userId,
      page: 1,
      queryFilters: {
        ticket_status: null,
        category: null,
        company_name: null,
        updated_at: null,
        created_at: null,
      },
    },
    {
      skip: !userId,
    }
  );

  return (
    <>
      <DashboardOperationsUserContainer>
        <RowContainer>
          <PieChartProjects data={projectsData} />
          <TicketsReview data={ticketsData} />
        </RowContainer>
        <AddNewWork />
      </DashboardOperationsUserContainer>
    </>
  );
}
